import { useFormatOptions } from "src/hooks";
import { formatPrice } from "src/utils/formatters";

export interface FlatPriceText {
    amount: number;
    className?: string;
    isZeroValue?: boolean;
}

export function FlatPrice({ className, amount, isZeroValue }: FlatPriceText): JSX.Element {
    const formatOptions = useFormatOptions();

    if (amount === null || amount === undefined || (isZeroValue && amount === 0)) {
        return <span className={className}>{"—"}</span>;
    }

    return <span className={className}>{formatPrice(amount, formatOptions)}</span>;
}

export default FlatPrice;
